import { CalcStatus } from '../types/contracts';

/**
 * statusを計算ステータスの日本語名に変換。
 * @param status CalcStatus
 * @returns string
 */
export const getCalcStatusText = (status: CalcStatus) => {
  switch (status) {
    case 'uncalced':
      return '未計算';
    case 'completed':
      return '計算済';
    case 'incomplete':
      return '配車不可';
    case 'partComplete':
      return '一部計算済';
    case 'updateContract':
      return '更新あり';
    default:
      throw new Error(`Unknown calculation status: ${status satisfies never}`);
  }
};
